import axios from "axios";
import {formDataHandler} from "@/services/form";
const errorsHandler = require("@/services/errors")

//Change This
const module = 'reviews'

const state = {
    filter: {
        center_id : null,
    },
    options_pagination: {
        page: 1,
        limit: 10
    },
}

const getters = {
    getFilter: state => {
        return state.filter
    },

    getOptionsPagination: state => {
        return state.options_pagination
    },
}

const actions = {
    index : async (context,payload = {}) => {

        let url = `api/v1/${module}`;

        var params = ''

        params = `?page=${context.state.options_pagination.page}&limit=${context.state.options_pagination.limit}`

        if(context.state.filter.center_id){
            params += `&center_id=${context.state.filter.center_id}`
        }

        if(!context.rootGetters['user/getUser'].super_admin){
            params += `&center_id=${context.rootGetters['user/getUser'].center_id}`
        }

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}${params}`, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data.result

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    store : async (context,payload) => {

        let url = `api/v1/${module}/store/`;

        var formData = await formDataHandler(payload)

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, formData,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    edit : async (context,payload) => {

        let url = `api/v1/${module}/${payload.id}`;

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}`,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    update : async (context,payload) => {

        let url = `api/v1/${module}/update/${payload.id}`;

        var formData = await formDataHandler(payload.item)

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`,formData,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    delete : async (context,payload) => {

        let url = `api/v1/${module}/delete/${payload.id}`;

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`,{},{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    massDelete : async (context,payload) => {

        let url = `api/v1/${module}/mass-delete`;

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`,payload,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },

    setFilter: async (context,value) => {
        context.commit('SET_FILTER', value)
    },

    setOptionsPagination: async (context,value) => {
        context.commit('SET_OPTIONS_PAGINATION', value)
    },
}

const mutations = {
    SET_FILTER: (state, value) => {
        state.filter = value
    },
    SET_OPTIONS_PAGINATION: (state, value) => {
        state.options_pagination = value
    },
}


export default {
    namespaced : true,
    state,
    mutations,
    getters,
    actions
}

